export default __webpack_public_path__ + "static/tooltip-critical-do-light-e6315816dd5f0919a3caf1b344868853d3f9fd42000715d34114b12b573fa967.png";